import { SBCRewardType } from "../api/privateRequests/sbcs/getSbcSets";

export const extractRewardUrl = (reward: SBCRewardType) => {
  let sbcRewardUrl: string;
  switch (reward?.type) {
    case "player":
      sbcRewardUrl = reward?.rewardImgURL;
      break;
    case "item":
      sbcRewardUrl = reward?.rewardImgURL;
      break;
    case "pack":
      sbcRewardUrl = reward?.packImageURL;
      break;
    case "playerpick":
      sbcRewardUrl = `${
        import.meta.env.VITE_APP_ASSETS_BASE_URL
      }/fut23/misc/playerpick.png`;
      break;
    case "cosmetic-evo":
      sbcRewardUrl = reward?.rewardImgURL;
      break;
  }
  return sbcRewardUrl;
};
